import api from './api'

const SESSION_KEY = 'redsterna_analytics_session'

const getSessionId = () => {
  try {
    const existing = window.localStorage.getItem(SESSION_KEY)
    if (existing) return existing

    const generated =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `session-${Date.now()}-${Math.random().toString(36).slice(2)}`

    window.localStorage.setItem(SESSION_KEY, generated)
    return generated
  } catch {
    return undefined
  }
}

export const trackEvent = (payload: {
  eventType: string
  entityType?: string
  entityId?: string
  value?: string
  metadata?: Record<string, any>
}) => {
  try {
    void api
      .post('/analytics/events', {
        ...payload,
        sessionId: getSessionId()
      })
      .catch(() => undefined)
  } catch {
    return
  }
}
